export default __webpack_public_path__ + "static/media/defaultLeague_banner.3e893e08.png";